import { exists } from '@aboutyou/legacy-shared/src/utils/exists'
import { useDisplayBrowserState } from 'helpers/hooks/useDisplayBrowserState'
import React from 'react'
import { useService } from 'services/utils/context'
import { usePremiumPageStore } from 'store/context'
import styled from 'styled-components'
import HeroSlider from 'uiComponents/organisms/HeroSlider/HeroSlider'
import PremiumHeroSlide from './PremiumHeroSlide'

const StyledHeroSlider = styled(HeroSlider)`
  margin-top: 0;
`

const PremiumHeroSlider: React.FC = () => {
  const isClientSide = useDisplayBrowserState()
  const service = useService()

  const premiumStoryIds = usePremiumPageStore(
    store => store.storyIdsForHeroSlider,
  )

  const stories = premiumStoryIds
    .map(storyId => service.stories.getById(storyId))
    .filter(exists)

  if (stories.length === 0) {
    return null
  }

  return (
    <StyledHeroSlider>
      {isClientSide ? (
        stories.map(story => <PremiumHeroSlide key={story.id} story={story} />)
      ) : (
        <PremiumHeroSlide story={stories[0]} />
      )}
    </StyledHeroSlider>
  )
}

export default PremiumHeroSlider
